var map = {
	"./01_dutch-oven.png": 7420,
	"./02_baking-sheet.png": 5676,
	"./03_food-processor.png": 7372,
	"./04_frying-pan.png": 1277,
	"./05_baking-pan.png": 6998,
	"./06_tinfoil.png": 4233
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2394;